import type { MouseEvent as ReactMouseEvent } from "react"

// True for clicks the browser should handle natively (cmd/ctrl-click opening
// a new tab, shift-click a new window, middle-click, …) instead of being
// intercepted for client-side navigation.
export const isModifiedClick = (ev: ReactMouseEvent) =>
  ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey || ev.button !== 0
